import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { OrganisationService } from '../../main-layout/organisation/organisation.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { BaseClass } from '../../utility/baseClass';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';

@Component({
  selector: 'app-organisationcrmusermodal',
  templateUrl: './organisationcrmusermodal.component.html',
  styleUrls: ['./organisationcrmusermodal.component.css']
})
export class OrganisationcrmusermodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  form: FormGroup;
  saveTitle = "Modify";
  OrganisationForm: FormGroup;
  loginuserid = 0;

  yesnolist = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' }
  ]

  orgid: any
  existingdetails: any;
  public validation_message = {
    'orgname': [{ type: 'required', message: 'Organisation is required' }],
    'noofcompany': [{ type: 'required', message: 'No of entity is required' },
         { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` }
    ],
    'noofuser': [{ type: 'required', message: 'No of user is required' },
         { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` }
    ],
    'nooflocation': [{ type: 'required', message: 'No of location is required' },
         { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` }
    ],
    'nooftraining': [{ type: 'required', message: 'No of training is required' },
         { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` }
    ],
    'spaceallowed': [{ type: 'required', message: 'Space allowed is required' },
         { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` }
    ],
    'databackupdownloadflag': [{ type: 'required', message: 'Data Backup is Required' }],
    'issuspended': [{ type: 'required', message: 'Suspended is Required' }],
    'requirebusinessuser': [{ type: 'required', message: 'Business user is Required' }],
    'noofbuser': [{ type: 'required', message: 'Number of business user is Required' },
         { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` }
    ]
  }
  commonScrollHeight = ''

  constructor(public override injector: Injector, private fb: FormBuilder, private orgservice: OrganisationService, public ref: DynamicDialogRef,
    public utilityservice: Utilityservice, public config: DynamicDialogConfig, private spinnerservice: NgxSpinnerService, private el: ElementRef,) {
    super(injector);
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    const datafromparent = this.config.data;
    this.orgid = datafromparent.orgid;
    this.existingdetails = datafromparent.datas;
    const userdata = this.utilityservice.getLoggeduser();
    this.loginuserid = userdata.userid;
  }

  ngOnInit() {
    this.formInitial();
    if (this.existingdetails) {
      this.patchValue(this.existingdetails);
    }

  }
  patchValue(data) {
    this.OrganisationForm.patchValue({
      orgname: data.name,
      noofcompany: data.noofcompany,
      nooflocation: data.nooflocation,
      noofuser: data.noofuser,
      spaceallowed: data.spaceallowed,
      nooftraining: data.nooftraining,
      issuspended: data.issuspended,
      requirebusinessuser: data.requirebusinessusers,
      noofbuser: data.noofbusinessusers,
      databackupdownloadflag: data.backupdownloadflag,

    })
    this.previousEntity = data.noofcompany;
    this.previousNumberOfUser = data.noofuser;
    this.previousNumberOfLocation = data.nooflocation;
    this.previousSpace = data.spaceallowed;    
    this.previousNumberOfTraning = data.nooftraining;    
    this.previousIsSuspended = data.issuspended;    
    this.previousNumberOfBusinessUser = data.noofbusinessusers;    
    this.previousIsBusinessUserRequired = data.requirebusinessusers;      
    this.orgName = data.name;

  }


  formInitial() {
    this.OrganisationForm = this.fb.group({
      orgname: ['', Validators.required],
      noofcompany: ['',Validators.compose([Validators.required, Validators.maxLength(6),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
       noofuser: ['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
       nooflocation: ['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],

      spaceallowed: ['', Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
      nooftraining: ['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
      issuspended: ['', Validators.required],
      requirebusinessuser: ['', Validators.required],
      noofbuser: ['', Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
      databackupdownloadflag: ['Y', Validators.required]
    })
  }

  modifyBd() {
    if (this.OrganisationForm.invalid) {
       Swal.fire('Please fill up/Validate all the mandatory/required fields and then Save!', '', 'warning').then(() => {
              this.validateAllFormFields(this.OrganisationForm, this.el); //{7}
      
            })
      return;
    }

    const payload: any = {};
    payload.bd_prev_noofentity = this.previousEntity;
    payload.bd_noofcompany = this.OrganisationForm.value.noofcompany;

    payload.bd_prev_noofuser = this.previousNumberOfUser;
    payload.bd_noofuser = this.OrganisationForm.value.noofuser;

    payload.bd_prev_nooflocation = this.previousNumberOfLocation;
    payload.bd_nooflocation = this.OrganisationForm.value.nooflocation;

    payload.bd_prev_noofspace = this.previousSpace;
    payload.bd_spaceallowed = this.OrganisationForm.value.spaceallowed;

    payload.bd_prev_nooftraining = this.previousNumberOfTraning;
    payload.bd_nooftraining = this.OrganisationForm.value.nooftraining;

    payload.bd_prev_issuspended = this.previousIsSuspended;
    payload.bd_issuspended = this.OrganisationForm.value.issuspended;

    payload.bd_prev_noofbusers = this.previousNumberOfBusinessUser;
    payload.bd_noofbusers = this.OrganisationForm.value.noofbuser;

    payload.bd_prev_requirebusinessuser = this.previousIsBusinessUserRequired;
    payload.bd_requirebusinessuser = this.OrganisationForm.value.requirebusinessuser;

    payload.bd_id = this.orgid;
    payload.bd_orgname  = this.orgName;

    payload.bd_databackupdownloadflag = this.OrganisationForm.value.databackupdownloadflag;

 

     Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      })
        .then((value) => {
          if (value.isConfirmed) {    
    
        
            let data = this.OrganisationForm.value;     
            data['csrftoken'] = this.CSRFToken;
            this.spinnerservice.show()
            this.orgservice.modifybduser(payload).subscribe({
              next: (response: any) => {
               this.spinnerservice.hide()
                if (response?.response == 'success') {
                  Swal.fire("Details modified successfully!", "", "success").then(() => {
                    this.ref.close()
                  });
                }
                else {
                  Swal.fire("Errr!", "", "error").then(() => {
                    this.ref.close();
                  });
                }
              },
              error: (error) => {
                               this.spinnerservice.hide()
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.error?.error || "An unexpected error occurred.",
                  footer: `Error status is: ${error.status}`
                });
              }
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
            this.ref.close();
          }
        });
  }
 

  previousEntity: String;
  previousNumberOfUser: String;
  previousNumberOfLocation: String;
  previousSpace: String;
  previousNumberOfTraning: String;
  previousIsSuspended: String;
  previousNumberOfBusinessUser: String;
  previousIsBusinessUserRequired: String;
  orgName: String;


  //     Swal.fire({
  //       title: "Do you want to save the changes?",
  //       showDenyButton: true,
  //       showCancelButton: true,
  //       confirmButtonText: "Save",
  //       denyButtonText: `Don't Save`
  //     }).then((value) => {
  //       if (value.isConfirmed) {
  //         let data = this.OrganisationForm.value;
  //         data['csrftoken'] = this.CSRFToken
  //         this.orgservice.modifybduser(this.LocationForm.value).subscribe((data) => {
  //           this.templocation = data;
  //           if (this.templocation.response == 'exists') {
  //             Swal.fire("Location name already exists!", " ", "error").then(result => {
  //               //this.ref.close()
  //             });
  //           }
  //           else {
  //             Swal.fire("Location added successfully!", "", "success").then(result => {
  //               this.ref.close('Save');
  //             });
  //           }
  //         }, error => {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Oops...",
  //             text: error.error.error,
  //             footer: "error status is :" + ' ' + error.status
  //           });
  //         });
  //       } else if (value.isDenied) {
  //         Swal.fire("Changes are not saved", "", "info");
  //         this.ref.close();
  //       }
  //     });

  // }




}
